// extracted by mini-css-extract-plugin
var _1 = "markdownReportModal-module_closeBtn__ZUsre3";
var _2 = "markdownReportModal-module_content__pOK_EH";
var _3 = "markdownReportModal-module_overlay__vPNNtv";
var _4 = "markdownReportModal-module_scrollArea__mEfYcR";
var _5 = "markdownReportModal-module_window__kp7GCC";
export { _1 as "closeBtn", _2 as "content", _3 as "overlay", _4 as "scrollArea", _5 as "window" }
